// extracted by mini-css-extract-plugin
export var block = "faq-module--block--KDDwZ";
export var container = "faq-module--container--2N173";
export var head = "faq-module--head--8q9uL";
export var root = "faq-module--root--xVSFh";